import React, { Component } from 'react';
import {
  ButtonStyle,
  ButtonWrapper,
  DeleteSVG,
  DownloadWrapper,
  InputWrapper,
  LoadWrapper,
  NameInput,
  TextStyle,
  TitleStyle
} from './LocalMapsElement';
import { crearMapConfig, downloadMap } from '../../../../CompartirUtils';
import { getTranslatedKey } from '../../../../../../Utils/TranslateUtils';
import { displayComponents } from '../../../../../../Utils/VisorsUtils';
import { toast } from 'react-toastify';

export default class LocalMaps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: ''
    };
    this.hiddenFileInput = React.createRef();
  }

  handleInputChange = (e) => {
    this.setState({ fileName: e.target.value });
  };
  deleteInput = () => {
    this.setState({ fileName: '' });
  };

  downloadToHardDrive = () => {
    if (this.state.fileName !== '') {
      let conf = crearMapConfig(
        this.props.map,
        this.props.arrayLayers,
        this.props.fonsActiu,
        this.props.transparenciaFons,
        this.state.fileName,
        this.props.vectorTilesSource,
        this.props.favList
      );
      downloadMap(conf, true);
    } else {
      toast.error(getTranslatedKey('errorNoName'));
    }
  };

  loadFromHardDrive = () => {
    this.hiddenFileInput.current.click();
  };
  handleFile(event) {
    const file = event.target.files[0];
    const reader = new FileReader();
    const self = this;
    reader.readAsText(file);
    reader.onload = function (evt) {
      self.props.loadMap(evt.target.result);
    };
  }

  render() {
    return (
      <>
        <DownloadWrapper>
          <TitleStyle>{getTranslatedKey('saveCatLocal')}</TitleStyle>
          <TextStyle>{getTranslatedKey('fileName')}:</TextStyle>
          <InputWrapper>
            <NameInput onChange={(e) => this.handleInputChange(e)} placeholder={getTranslatedKey('fileNamePH')} value={this.state.fileName} />
            {this.state.fileName !== '' && (
              <DeleteSVG onClick={() => this.deleteInput()}>
                <svg
                  alt={getTranslatedKey('esborrarCercaBtn')}
                  title={getTranslatedKey('esborrarCerca')}
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  viewBox="0 0 24 24"
                  width="22"
                  fill="white"
                  height="22"
                  class="sc-kDvujY bwDwBu">
                  <path
                    xmlns="http://www.w3.org/2000/svg"
                    d="M19,15.59L17.59,17L14,13.41L10.41,17L9,15.59L12.59,12L9,8.41L10.41,7L14,10.59L17.59,7L19,8.41L15.41,12L19,15.59M22,3A2,2 0 0,1 24,5V19A2,2 0 0,1 22,21H7C6.31,21 5.77,20.64 5.41,20.11L0,12L5.41,3.88C5.77,3.35 6.31,3 7,3H22M22,5H7L2.28,12L7,19H22V5Z"></path>
                </svg>
              </DeleteSVG>
            )}
          </InputWrapper>
          <ButtonWrapper>
            <ButtonStyle onClick={() => this.downloadToHardDrive()}>
              <svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="22" fill="white" viewBox="0 0 512 512">
                <g>
                  <path d="M359.1,262.5c-11.8-10.1-29.7-8.8-39.8,3.1l-35,40.9V43.9c0-15.6-12.6-28.2-28.2-28.2c-15.6,0-28.2,12.6-28.2,28.2v262.6   l-35-40.9c-10.2-11.8-28-13.2-39.8-3.1c-11.8,10.2-13.2,28-3.1,39.8l0,0l84.7,98.9c10.2,11.8,28,13.2,39.8,3.1   c1.1-0.9,2.1-2,3.1-3.1l84.7-98.9C372.3,290.5,371,272.7,359.1,262.5z" />
                  <g>
                    <line class="st0" x1="460" y1="472.1" x2="52" y2="472.1" />
                    <path
                      class="st0"
                      d="M460,499.5c-113.9,0.6-292.8,0.9-408,1c-15.7,0-28.5-12.7-28.5-28.5c0-15.8,12.8-28.6,28.5-28.5    c115.7,0.2,293.6,0.4,408,1C496.2,446.1,496.4,497.9,460,499.5L460,499.5z"
                    />
                  </g>
                </g>
              </svg>
              <TextStyle>{getTranslatedKey('desaLocal')}</TextStyle>
            </ButtonStyle>
          </ButtonWrapper>
        </DownloadWrapper>
        <LoadWrapper>
          <TitleStyle>{getTranslatedKey('loadFile')}</TitleStyle>
          <ButtonWrapper>
            <ButtonStyle onClick={() => this.loadFromHardDrive()}>
              <input
                ref={this.hiddenFileInput}
                onChange={(e) => this.handleFile(e)}
                type="file"
                style={{ display: 'none', width: '100%', height: '100%' }}
                accept=".xml"
              />
              <svg viewBox="0 0 512 512" fill="#fff" xmlns="http://www.w3.org/2000/svg" version="1.1" width="22">
                <path d="M152.9,164.2c11.8,10.1,29.7,8.8,39.8-3.1l35-40.9v262.6c0,15.6,12.6,28.2,28.2,28.2s28.2-12.6,28.2-28.2V120.2l35,40.9  c10.2,11.8,28,13.2,39.8,3.1c11.8-10.2,13.2-28,3.1-39.8l0,0l-84.7-98.9c-10.2-11.8-28-13.2-39.8-3.1c-1.1,0.9-2.1,2-3.1,3.1  l-84.7,98.9C139.7,136.2,141,154,152.9,164.2z"></path>
                <g>
                  <line class="st0" x1="460" y1="472.1" x2="52" y2="472.1"></line>
                  <path
                    class="st0"
                    d="M460,499.5c-113.9,0.6-292.8,0.9-408,1c-15.7,0-28.5-12.7-28.5-28.5c0-15.8,12.8-28.6,28.5-28.5   c115.7,0.2,293.6,0.4,408,1C496.2,446.1,496.4,497.9,460,499.5L460,499.5z"></path>
                </g>
              </svg>
              <TextStyle>{getTranslatedKey('loadMap')}</TextStyle>
            </ButtonStyle>
          </ButtonWrapper>
        </LoadWrapper>
      </>
    );
  }
}
